<template>
  <div id="login" >
    <form class="box" @submit.prevent="login">
      <h1 class="h3 mb-3 font-weight-normal title">Please Sign In</h1>
      <div class="alert has-text-warning mx-4 has-background-danger px-4" style="border-radius: 10px;" role="alert" v-if="invalidCredentials">
        Can't log you in, check your username and password and your network connection!
      </div>
      <div
        class="alert has-text-success"
        role="alert"
        v-if="this.$route.query.registration"
      >
        Thank you for registering, please sign in.
      </div>
      <div class="mx-4">
        <label for="username">Username</label>
        <input
          type="text"
          id="username"
          placeholder="Username"
          class="input is-rounded"
          v-model="user.username"
          required
          autofocus
        />
      </div>
      <div class="mx-4">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          class="input is-rounded"
          placeholder="Password"
          v-model="user.password"
          required
        />
      </div>
      <div class="mx-4 has-text-right">
        <button type="submit" class="button is-rounded mt-3 is-success">Sign in</button>
      </div>
      <div id="needAccount" class="mt-2">
        <router-link :to="{ name: 'register' }">Need an account?</router-link>
      </div>
    </form>
    <div class="alert has-text-warning mx-4 px-4" style="border-radius: 10px;" role="alert" v-if="easterEgg">
        <img src="/teapot.gif">
    </div>

  </div>
</template>

<script>
import authService from "../services/AuthService";
import accountService from "../services/AccountService";

export default {
  name: "login-page",
  components: {},
  data() {
    return {
      user: {
        username: "",
        password: "",
      },
      invalidCredentials: false,
      easterEgg: false
    };
  },
  methods: {
    refreshAllData() {
      accountService.getBalance().then((response) => {
        this.$store.commit("SET_BALANCE", response.data.balance);
      });
      accountService.getTransfers().then((response) => {
        this.$store.commit("SET_TRANSACTIONS", response.data);
      });
    },
    login() {
      const loginObject = {
        username: this.user.username.toLowerCase(),
        password: this.user.password,
      };
      authService
        .login(loginObject)
        .then((response) => {
          if (response.status == 200) {
            this.$store.commit("SET_AUTH_TOKEN", response.data.token);
            this.$store.commit("SET_USER", response.data.user);
            this.refreshAllData();
            this.easterEgg = false;
            this.$router.push("/");
          }
        })
        .catch((error) => {
          // const response = error.response;
            if(error.response.status === 418){
              this.easterEgg = true;
            }
            this.invalidCredentials = true;
        });
    },
  },
};
</script>

<!-- <style scoped>
#login {
  margin-left: 75px;
}

form > label {
  display: block;
  margin-bottom: 5px;
}

form > input {
  margin-bottom: 10px;
}
form > button {
  display: block;
  margin-bottom: 10px;
}
#needAccount {
  margin-top: 2%;
}
</style> -->